export default __webpack_public_path__ + "static/media/title_zh_cn_sp.6f4c7089.png";